import { Phone, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "../data/brand";

export default function StickyMobileCTA() {
  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-background/95 backdrop-blur-xl border-t border-border"
      data-testid="sticky-mobile-cta"
    >
      <div className="grid grid-cols-3 text-[11px] uppercase tracking-[0.18em] font-medium">
        <a href={BRAND.phone_link} className="flex items-center justify-center gap-2 py-4 text-foreground/80" data-testid="sticky-call">
          <Phone size={14} strokeWidth={1.25} /> Call
        </a>
        <a href={BRAND.whatsapp_link} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 py-4 text-foreground/80 border-x border-border" data-testid="sticky-whatsapp">
          <MessageCircle size={14} strokeWidth={1.25} /> WhatsApp
        </a>
        <Link to="/contact" className="flex items-center justify-center py-4 bg-accent text-accent-foreground" data-testid="sticky-quote">
          Get Quote
        </Link>
      </div>
    </div>
  );
}
